import React from 'react';
import { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import Chip from '../Chip';
import { FilterGroup } from '../ProductFiltering/types/FilterGroup';
import { FilterGroupType } from '../ProductFiltering/types/FilterGroupType';
import {
  clearFilterGroup,
  clearFilter,
} from '../../Actions/ProductFiltering.action';

interface FilterGroupChipsAttributes {
  filterGroup: FilterGroup;
}

const FilterGroupChips = (props: FilterGroupChipsAttributes) => {
  const dispatch = useDispatch();
  const { selectedOptions, id, label, filterGroupType } =
    props.filterGroup;
  if (selectedOptions.length == 0) return null;

  return (
    <>
      {filterGroupType != FilterGroupType.Range && (
        <>
          {selectedOptions.length > 0 &&
            selectedOptions.map((option) => (
              <Chip
                key={option + 'chip'}
                onDeleteClick={() => dispatch(clearFilter(option, id))}
              >
                {option}
              </Chip>
            ))}
        </>
      )}
      {filterGroupType == FilterGroupType.Range &&
        selectedOptions.length == 2 && (
          <Chip onDeleteClick={() => dispatch(clearFilterGroup(id))}>
            <span>
              <strong>{label}:</strong> {selectedOptions[0]}-
              {selectedOptions[1]}
            </span>
          </Chip>
        )}
    </>
  );
};

export default FilterGroupChips;
